import PropTypes from 'prop-types'

const props = {
    activityCount: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                day: PropTypes.number,
                hits: PropTypes.number,
            }),
            PropTypes.shape({
                hour: PropTypes.number,
                hits: PropTypes.number,
            }),
        ])
    ),
    topStores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    prevTopStores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    bottomStores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    prevBottomStores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    topModels: PropTypes.arrayOf(
        PropTypes.shape({
            brand: PropTypes.string,
            model: PropTypes.string,
            unique_visitors: PropTypes.number,
        })
    ),
    prevTopModels: PropTypes.arrayOf(
        PropTypes.shape({
            brand: PropTypes.string,
            model: PropTypes.string,
            unique_visitors: PropTypes.number,
        })
    ),
    topBrands: PropTypes.arrayOf(
        PropTypes.shape({
            brand: PropTypes.string,
            unique_visitors: PropTypes.number,
        })
    ),
    prevTopBrands: PropTypes.arrayOf(
        PropTypes.shape({
            brand: PropTypes.string,
            unique_visitors: PropTypes.number,
        })
    ),
    topChannels: PropTypes.arrayOf(
        PropTypes.shape({
            channel: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    prevTopChannels: PropTypes.arrayOf(
        PropTypes.shape({
            channel: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    bottomChannels: PropTypes.arrayOf(
        PropTypes.shape({
            channel: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    prevBottomChannels: PropTypes.arrayOf(
        PropTypes.shape({
            channel: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    topScreenSizes: PropTypes.arrayOf(
        PropTypes.shape({
            screensize: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    prevTopScreenSizes: PropTypes.arrayOf(
        PropTypes.shape({
            screensize: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    bottomScreenSize: PropTypes.arrayOf(
        PropTypes.shape({
            screensize: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    prevBottomScreenSize: PropTypes.arrayOf(
        PropTypes.shape({
            screensize: PropTypes.string,
            hits: PropTypes.number,
        })
    ),
    averagePrice: PropTypes.number,
    prevAveragePrice: PropTypes.number,
    userTypeCounts: PropTypes.arrayOf(
        PropTypes.shape({
            returnVisitor: PropTypes.number,
            newVisitor: PropTypes.number,
            colleague: PropTypes.number,
            customer: PropTypes.number,
        })
    ),
}

export default props
